import { Col, Menu, Row } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import logoAtaajy from "../../assets/images/ataajy-logo.png";
import { MAIN_MENU, ROUTES } from "../../utils/enums";
import "./styles.less";
import { ItemType } from "antd/lib/menu/hooks/useItems";

const MainMenu = () => {
  const [menuCurrentKey, setMenuCurrentKey] = useState(MAIN_MENU.NONE);

  const menuItems: ItemType[] = [
    { label: "Activités", key: MAIN_MENU.ACTIVITIES },
    {
      label: "Projects",
      key: MAIN_MENU.PROJECTS,
      children: [
        {
          label: <Link to={ROUTES.PROJECTS}>Projets effectués</Link>,
          key: MAIN_MENU.PROJECTS_DONE,
        },
        {
          label: <Link to={ROUTES.PROJECTS_ON_GOING}>Projets en cours</Link>,
          key: MAIN_MENU.PROJECTS_ONGOING,
        },
        {
          label: <Link to={ROUTES.PROJECTS_COMING}>Projets à venir</Link>,
          key: MAIN_MENU.PROJECTS_COMING,
        },
      ],
    },
    {
      label: "À propos de nous",
      key: MAIN_MENU.ABOUT_US,
    },
    {
      label: "Contact",
      key: MAIN_MENU.CONTACT,
    },
  ];

  const handleOnMenuClick = (e: any) => {
    setMenuCurrentKey(e.key);
  };

  return (
    <Row align="middle" className="mainmenu">
      <Link to={ROUTES.HOMEPAGE} className="mainmenu__logo">
        <img src={logoAtaajy} alt="Logo Ataajy" />
      </Link>
      <Col span={2} md={16} offset={8}>
        <Menu
          onClick={handleOnMenuClick}
          selectedKeys={[menuCurrentKey]}
          mode="horizontal"
          items={menuItems}
        />
      </Col>
    </Row>
  );
};

export default MainMenu;
